import { CalendarDays, ArrowUpRight } from "lucide-react";
import { SITE } from "@/config/site";

// Reusable CTA card for booking a discovery call.
// Variants: 'panel' (highlighted cream panel) | 'inline' (subtle)
export default function CalendlyCTA({
  variant = "panel",
  label = "Book a 30-minute discovery call",
  subtitle = "A quiet conversation. No pressure. No pitch.",
  testId = "calendly-cta",
}) {
  if (variant === "inline") {
    return (
      <a
        href={SITE.calendlyUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testId}
        className="inline-flex items-center gap-3 text-sm tracking-[0.18em] uppercase text-[#15243D] hover:text-[#C07865] transition-colors"
      >
        <CalendarDays size={16} strokeWidth={1.5} />
        {label}
        <ArrowUpRight size={14} strokeWidth={1.5} />
      </a>
    );
  }

  return (
    <div
      className="border border-[#15243D]/15 p-8 md:p-10 bg-[#EBE8E0]"
      data-testid={testId}
    >
      <div className="flex items-baseline justify-between gap-4 mb-4">
        <p className="overline">Next step</p>
        <CalendarDays
          size={20}
          strokeWidth={1.25}
          className="text-[#C07865]"
        />
      </div>
      <h3
        className="serif text-2xl md:text-3xl text-[#15243D] leading-snug mb-3"
        style={{ fontWeight: 300 }}
      >
        {label}
      </h3>
      <p className="text-base font-light text-[#5A5D63] mb-6 leading-relaxed">
        {subtitle}
      </p>
      <a
        href={SITE.calendlyUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`${testId}-button`}
        className="btn-primary"
      >
        Choose a time
        <ArrowUpRight size={16} strokeWidth={1.5} />
      </a>
    </div>
  );
}
